import styled from 'styled-components';
import { ColorConstants } from '@shared/constants';
import { MobileScreen } from '../styles/ConstantMediaQuery';
import { getZIndexByLayerName, LayerNames } from '../../constants/layers.constants';

export const TooltipTriangle = styled.div`
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid ${ColorConstants['violent-violet']};
    top: -3;
    left: 45%;
    position: relative;
    width: 0px;
`;

export const InfoTextTooltip = styled.span`
    color: ${ColorConstants.white};
    background-color: ${ColorConstants['violent-violet']};
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    padding: 5px 10px;
    white-space: nowrap;
    user-select: none;
`;

export const Info = styled.span`
    border-radius: 6px;
    bottom: ${({ bottom }) => bottom}; 
    left: ${({ left }) => left};
    opacity: 0;
    position: absolute;
    right: ${({ right }) => right};
    text-align: center;
    top: ${({ top }) => top};
    transition: all 0.3s ease; 
    visibility: hidden;
    width: 120px;
    z-index: ${getZIndexByLayerName(LayerNames.CURR_VALUE_2)};

    @media ${MobileScreen}{
        display: none;
    }
`;
